import myAxios from "@/utils/request";
export default {
  // 关键词推荐
  getKeywordList(params) {
    return myAxios.post("/api/searchmanagement/getsmlistback", params);
  },
  cancelKeyword(params) {
    return myAxios.post("/api/searchmanagement/cancelsearchmanagement", params);
  },
  addKeywordRecommend(params) {
    return myAxios.post("/api/searchmanagement/addsearchmanagement", params);
  },
  getKeywordAch(params) {
    return myAxios.post("/api/achievement/keysachipaging_rtat", params);
  },
  getKeywordDem(params) {
    return myAxios.post("/api/requirement/keysreqpaging_rtat", params);
  },
  getKeywordAct(params) {
    return myAxios.post("/api/news/keysbacactpaging", params);
  },
  getKeywordPol(params) {
    return myAxios.post("/api/policy/getpolicybyselectkeys", params);
  },
  // 首页推荐
  getHomepageList(params) {
    return myAxios.post("/api/recommendmanagement/getrmlistback", params);
  },
  cancelHomepage(params) {
    return myAxios.post(
      "/api/recommendmanagement/cancelrecommendmanagement",
      params
    );
  },
  addHomepageRecommend(params) {
    return myAxios.post(
      "/api/recommendmanagement/addrecommendmanagement",
      params
    );
  },
  getHomepageAch(params) {
    return myAxios.post("/api/achievement/firstkeysachipaging_rtat", params);
  },
  getHomepageDem(params) {
    return myAxios.post("/api/requirement/firstkeysreqpaging_rtat", params);
  },
  getHomepageAct(params) {
    return myAxios.post("/api/news/firstkeysbacactpaging", params);
  },
  getHomepagePat(params) {
    return myAxios.post("/api/patent/firstachipaging_im", params);
  },
  getHomepageNew(params) {
    return myAxios.post("/api/news/firstnewspaging", params);
  }
};
